import { initApp } from './core/app.js';

document.addEventListener('DOMContentLoaded', () => {
    initApp();
});